import { render, staticRenderFns } from "./dos.vue?vue&type=template&id=22cfdefc&"
import script from "./dos.vue?vue&type=script&lang=js&"
export * from "./dos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports